import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  height: "48px",
  viewBox: "0 0 1024 1024",
  width: "48px",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g transform=\"matrix(11.396615, 0, 0, 11.396615, -217.360474, -201.899063)\"><path d=\"m57.362 26.54-37.262 64.535a7.666 7.666 0 0 0 6.639 11.5h74.518a7.666 7.666 0 0 0 6.639-11.5l-37.258-64.535a7.665 7.665 0 0 0 -13.276 0z\" fill=\"#ffb400\"></path><g fill=\"#fcf4d9\"><rect height=\"29.377\" rx=\"4.333\" width=\"9.638\" x=\"59.181\" y=\"46.444\"></rect><circle cx=\"64\" cy=\"87.428\" r=\"4.819\"></circle></g></g>", 1)
  ]))]))
}
export default { render: render }